'use client';

import { useState } from 'react';
import { RecoveryCodeForm } from './recovery-code-form';
import { LoginForm } from './login-form';
import { OTPForm } from './otp-form';
import { Setup2FAForm, Setup2FAOptions } from './setup-2fa-form';

type View =
  | ['login', options?: { message?: string }]
  | ['otp']
  | ['recoveryCode']
  | ['setupTwoFactorAuth', Setup2FAOptions];

export type SetView = (...args: View) => void;

export default function Page() {
  const [[view, options], setView_] = useState<View>(['login']);
  const setView: SetView = (...args) => setView_(args);

  switch (view) {
    case 'login':
      return <LoginForm setView={setView} message={options?.message} />;
    case 'otp':
      return <OTPForm setView={setView} />;
    case 'recoveryCode':
      return <RecoveryCodeForm setView={setView} />;
    case 'setupTwoFactorAuth':
      return <Setup2FAForm setView={setView} {...options} />;
  }
}
